import type { ReactNode, PropsWithChildren } from 'react';

import { TextEllipsis } from '@dynatrace/strato-components/typography';

/**
 * Typeguard to check if the children is only a single string.
 * @internal
 */
export function hasSingleStringChild(children: ReactNode): children is string {
  return !Array.isArray(children) && typeof children === 'string';
}
/**
 * Typeguard to check if the children are an array of strings.
 * @internal
 */
export function hasArrayOfStringChildren(
  children: ReactNode,
): children is string[] {
  return (
    Array.isArray(children) &&
    children.every((child) => typeof child === 'string')
  );
}

/** Helper component to wrap the children into a TextEllpipsis if valid.
 * @internal
 */
export function TextEllipsisAroundChildren(props: PropsWithChildren) {
  const { children } = props;
  if (hasSingleStringChild(children)) {
    return <TextEllipsis>{children}</TextEllipsis>;
  }
  if (hasArrayOfStringChildren(children)) {
    return <TextEllipsis>{children.join('')}</TextEllipsis>;
  }

  return children;
}
